var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetamaskIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 46,
    viewBox: "0 0 49 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 47253"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M46.1308 0.896484L27.3789 14.7716L30.866 6.59453L46.1308 0.896484Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.87305 0.896484L21.458 14.9011L18.138 6.59451L2.87305 0.896484Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M39.3761 33.0684L34.3867 40.6904L45.0703 43.632L48.1307 33.235L39.3761 33.0684Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.888672 33.235L3.9305 43.632L14.5956 40.6904L9.62469 33.0684L0.888672 33.235Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.0203 20.191L11.0527 24.668L21.625 25.149L21.2726 13.7715L14.0203 20.191Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M34.9834 20.1935L27.6201 13.6445L27.3789 25.1516L37.9511 24.6706L34.9834 20.1935Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M14.5996 40.6901L20.9985 37.6006L15.4899 33.3086L14.5996 40.6901Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M28.0039 37.6006L34.3843 40.6901L33.5125 33.3086L28.0039 37.6006Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M34.3843 40.6891L28.0039 37.5996L28.5232 41.7436L28.4675 43.5011L34.3843 40.6891Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M14.5996 40.6891L20.535 43.5011L20.4978 41.7436L20.9985 37.5996L14.5996 40.6891Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M20.6426 30.5714L15.3379 29.0174L19.0845 27.2969L20.6426 30.5714Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M28.3594 30.5714L29.9175 27.2969L33.6827 29.0174L28.3594 30.5714Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M14.5938 40.6904L15.5213 33.0684L9.62305 33.235L14.5938 40.6904Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M33.4766 33.0684L34.3855 40.6904L39.3748 33.235L33.4766 33.0684Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M37.9511 24.6699L27.3789 25.1509L28.3619 30.5716L29.92 27.2969L33.6852 29.0175L37.9511 24.6699Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M15.3373 29.0175L19.0839 27.2969L20.642 30.5716L21.625 25.1509L11.0527 24.6699L15.3373 29.0175Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M11.0566 24.6699L15.4896 33.3095L15.3411 29.0175L11.0566 24.6699Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M33.6806 29.0175L33.5137 33.3095L37.9466 24.6699L33.6806 29.0175Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M21.6277 25.1504L20.6445 30.571L21.8872 36.972L22.1655 28.536L21.6277 25.1504Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M27.3768 25.1504L26.8574 28.5175L27.1171 36.972L28.3598 30.571L27.3768 25.1504Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M28.3599 30.5697L27.1172 36.9706L28.0075 37.5997L33.5163 33.3077L33.6832 29.0156L28.3599 30.5697Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M15.3379 29.0156L15.4864 33.3077L20.995 37.5997L21.8853 36.9706L20.6426 30.5697L15.3379 29.0156Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M28.4734 43.5035L28.5289 41.7459L28.0468 41.3389H20.9616L20.4978 41.7459L20.535 43.5035L14.5996 40.6914L16.677 42.3934L20.8873 45.298H28.1023L32.3313 42.3934L34.39 40.6914L28.4734 43.5035Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M28.0079 37.5996L27.1176 36.9707H21.8871L20.9969 37.5996L20.4961 41.7437L20.9598 41.3367H28.0451L28.5273 41.7437L28.0079 37.5996Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M46.9226 15.678L48.4992 8.01903L46.125 0.896484L28.0039 14.3091L34.9778 20.1921L44.8267 23.0597L46.9968 20.5252L46.0509 19.8406L47.5532 18.4717L46.4033 17.5836L47.9057 16.4366L46.9226 15.678Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M0.5 8.01903L2.09511 15.678L1.07499 16.4366L2.5959 17.5836L1.44594 18.4717L2.94831 19.8406L2.00237 20.5252L4.17247 23.0597L14.0214 20.1921L20.9953 14.3091L2.87412 0.896484L0.5 8.01903Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M44.8278 23.0608L34.9789 20.1934L37.9466 24.6704L33.5137 33.3099L39.3748 33.2359H48.1293L44.8278 23.0608Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M14.0205 20.1934L4.17163 23.0608L0.888672 33.2359H9.62469L15.4857 33.3099L11.0529 24.6704L14.0205 20.1934Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M27.3774 25.1494L28.0081 14.3082L30.8644 6.59375H18.1406L20.9969 14.3082L21.6276 25.1494L21.8687 28.5534L21.8873 36.971H27.1177L27.1363 28.5534L27.3774 25.1494Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamaskIcon);
export default __webpack_public_path__ + "static/media/metamask-icon.caab9a51f2ae68247204e77d33d0a88d.svg";
export { ForwardRef as ReactComponent };